/** Error correction level for QR code */
export type ErrorCorrectionLevel = 'L' | 'M' | 'Q' | 'H';

/** Style of QR code modules (data dots) */
export type DotStyle = 'square' | 'rounded' | 'dot';

/** Full configuration for QR code generation */
export interface QRCodeConfig {
  /** The text content to encode */
  text: string;
  /** Color of the dark modules (default: #000000) */
  foregroundColor: string;
  /** Background color (default: #ffffff) */
  backgroundColor: string;
  /** Error correction level */
  errorCorrectionLevel: ErrorCorrectionLevel;
  /** Quiet zone margin (number of modules) */
  margin: number;
  /** Pixel size of the output canvas */
  size: number;
  /** Module dot style */
  dotStyle: DotStyle;
  /** Optional logo image data URL */
  logoDataUrl?: string;
  /** Logo size as percentage of QR code size (10-50) */
  logoSize: number;
}

export const DEFAULT_CONFIG: QRCodeConfig = {
  text: '',
  foregroundColor: '#000000',
  backgroundColor: '#ffffff',
  errorCorrectionLevel: 'M',
  margin: 4,
  size: 400,
  dotStyle: 'square',
  logoSize: 20,
};

export const ERROR_CORRECTION_LEVELS: { value: ErrorCorrectionLevel; label: string; description: string }[] = [
  { value: 'L', label: 'L（低）', description: '可恢复 7% 数据' },
  { value: 'M', label: 'M（中）', description: '可恢复 15% 数据' },
  { value: 'Q', label: 'Q（较高）', description: '可恢复 25% 数据' },
  { value: 'H', label: 'H（高）', description: '可恢复 30% 数据' },
];

export const DOT_STYLES: { value: DotStyle; label: string }[] = [
  { value: 'square', label: '方块' },
  { value: 'rounded', label: '圆角' },
  { value: 'dot', label: '圆点' },
];
